import React from 'react';
import { Header } from '../../layout';
import ListTrainings from '../../lists/ListTrainings.jsx';

const PageTrainings = () => (
  <div>
        <Header>Trainings</Header>
        <ListTrainings />
  </div>
);

export { PageTrainings };
export default PageTrainings;
